import { render, staticRenderFns } from "./HrFeedFieldsTable.vue?vue&type=template&id=1a4a6743"
import script from "./HrFeedFieldsTable.vue?vue&type=script&lang=js"
export * from "./HrFeedFieldsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports